/**
 * Context-specific copy for "What we do with your number?" disclosures.
 */

export const PHONE_NUMBER_DISCLOSURE_LABEL = 'What we do with your number?' as const;

export type PhoneNumberPurpose =
  | 'account_contact'
  | 'academy_registration'
  | 'sms_notifications'
  | 'emergency_contact'
  | 'academy_public'
  | 'coach_contact'
  | 'guest_inquiry'
  | 'platform_contact'
  | 'student_matching'
  | 'club_court_hire'
  | 'general';

export const PHONE_NUMBER_DISCLOSURE: Record<PhoneNumberPurpose, string> = {
  account_contact:
    'We use your number to contact you about your account, bookings, and academy-related updates. We do not sell your number.',
  academy_registration:
    'We use your number for account contact and urgent transactional SMS from this academy (lesson cancellations, postponements, and waitlist alerts). Reply STOP to opt out. We do not sell your number.',
  sms_notifications:
    'Used only for urgent transactional SMS from this academy—lesson cancellations, postponements, and waitlist alerts. Reply STOP to opt out.',
  emergency_contact:
    'Shared with the academy and coaches for emergencies involving the student. Used only when urgent contact is needed.',
  academy_public:
    "May appear on your academy's public page and in communications so families can reach you.",
  coach_contact:
    'May be shown to students and guardians for lesson-related contact.',
  guest_inquiry:
    'Used only to follow up on your inquiry. We do not add you to marketing lists without consent.',
  platform_contact:
    'Used only to respond to your CourtSync inquiry or demo request. We do not sell your number.',
  student_matching:
    'Stored to help match this student when a guardian registers with the same contact details. Not used for marketing.',
  club_court_hire:
    'We use your number to contact you about your court hire booking and other club-related activities. We do not sell your number.',
  general:
    'Used only for purposes related to your CourtSync account and academy activity. We do not sell your number.',
};

export function getPhoneNumberDisclosure(purpose: PhoneNumberPurpose = 'general'): string {
  return PHONE_NUMBER_DISCLOSURE[purpose] ?? PHONE_NUMBER_DISCLOSURE.general;
}
